

















import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'

export default Vue.extend({
  components: {
    appConfirmDialog: CreateDialog,
  },
  props: {
    to: Object as PropType<{ name: string }>,
  },
  methods: {
    exit() {
      this.$router.push(this.to)
    },
  },
})
